module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "secondary"
    }
  }, [_c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    class: ['content', _vm.layoutClass]
  }, _vm._l((_vm.visualizationLayerTypes), function(visualizationLayerType) {
    return _c('map-component', {
      key: visualizationLayerType,
      class: 'layer-' + visualizationLayerType,
      attrs: {
        "visualizationLayerType": visualizationLayerType
      }
    })
  }), 1), _vm._v(" "), _c('automatic-area-updater', {
    attrs: {
      "visualizationLayerTypes": _vm.visualizationLayerTypes
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c564b8f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/index.vue
// module id = 906
// module chunks = 0